
(function () {
  'use strict';

  const STYLE_ID = 'sarris-forms-style';

  const STYLES = `
    section[data-sizing="form-wrapper"] {
      max-width: 100% !important;
      margin: 0 !important;
    }

    [class*="_gridItem_"],
    [class*="_gridItemContent_"] {
      padding-bottom: 0 !important;
    }

    button[type="submit"],
    [type="submit"],
    button.shopify-forms-submit-button,
    .shopify-forms-submit-button {
      border-radius: 100px !important;
      padding: 16px 36px !important;
      font-family: 'Barlow Condensed', sans-serif !important;
      font-weight: 700 !important;
      font-size: 14px !important;
      letter-spacing: 0.13em !important;
      text-transform: uppercase !important;
      background: #c8102e !important;
      color: #ffffff !important;
      border: none !important;
      cursor: pointer !important;
      width: auto !important;
      display: block !important;
      margin-inline: auto !important;
      margin-top: 8px !important;
      transition: transform 0.2s ease, box-shadow 0.25s ease, background-color 0.2s ease !important;
      box-shadow: 0 4px 14px -6px rgba(200, 16, 46, 0.5) !important;
    }

    button[type="submit"]:hover,
    [type="submit"]:hover,
    button.shopify-forms-submit-button:hover,
    .shopify-forms-submit-button:hover {
      background: #a30d24 !important;
    }

  `;

  function injectStyles(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLES;
    shadowRoot.appendChild(style);
  }

  function processEmbed(embed) {
    if (!embed) return;
    if (embed.shadowRoot) {
      injectStyles(embed.shadowRoot);
      return;
    }
    const obs = new MutationObserver(() => {
      if (embed.shadowRoot) {
        injectStyles(embed.shadowRoot);
        obs.disconnect();
      }
    });
    obs.observe(embed, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 10000);
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(processEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const docObs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
          processEmbed(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('shopify-forms-embed').forEach(processEmbed);
        }
      }
    }
  });
  docObs.observe(document.body, { childList: true, subtree: true });
})();
